import React from 'react';

const Basket: React.FC = () => {
  return (
    <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.37052 6.92055L11.3214 2.20789L14.6377 6.65293L17 6.56511L12.132 0.041816L10.6295 0L5 6.71983L5.31525 7L7.37052 6.92055Z" />
      <path d="M0 9.44136L2.49347 20.6169L19.1341 21L22 9L0 9.44136ZM6.7356 18.4684H5.15695V11.5732H6.7356V18.4684ZM11.4675 18.4684H9.88887V11.5732H11.4675V18.4684ZM16.1954 18.4684H14.637V11.5732H16.2116L16.1954 18.4684Z" />
    </svg>
  );
};

export { Basket };
